import axios, { AxiosPromise, AxiosRequestConfig } from "axios";
import * as http from "../../../services/http.service";

export const authenticatedFileDownloadHandler = (url: string, accept?: string): AxiosPromise => {
  return http.getAxiosInstance()(getAxiosConfig(url, accept));
};

export const defaultFileDownloadHandler = (url: string, accept?: string): AxiosPromise => {
  return axios(getAxiosConfig(url, accept));
};

function getAxiosConfig(url: string, accept?: string): AxiosRequestConfig {
  return {
    url,
    method: "GET",
    responseType: "blob",
    ...(accept ? { headers: { Accept: accept } } : {}),
  };
}
